// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2yimE","amount":"Amount_amount__2Ku9Q","tip":"Amount_tip__Ot0Q3","tipHeader":"Amount_tipHeader__14Q-T","tipsWrap":"Amount_tipsWrap__19Qiw"};